import axios from 'axios'
import store from '../redux/store'
// import { loadToken, logout } from '../redux/slice/authSlice';
const LOGIN_URL = "/login/"

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
});
const axiosUnauthInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
});

const getAccessToken = () => store.getState().auth.access_token;

// Add a request interceptor
axiosInstance.interceptors.request.use(
    (request) => {
        const token = getAccessToken();
        if (!token && request.url !== LOGIN_URL) {
            const controller = new AbortController();
            request.signal = controller.signal;
            controller.abort()
            return Promise.reject(new axios.Cancel("Request aborted due to authentication failure"));
        }
        if (token) {
            request.headers["Authorization"] = `Bearer ${token}`;
        }
        if (request.data instanceof FormData) request.headers["Content-Type"] = "multipart/form-data"
        else request.headers["Content-Type"] = "application/json"
        return request;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        return Promise.reject(error);
    }
);

const apiRequest = async (method, endpoint, data = null, params = null, headers = {}) => {
    try {
        const response = await axiosInstance({
            method,
            url: endpoint,
            data,
            params,
            headers
        })
        return response;
    } catch (error) {
        console.log(`API Error [${method.toUpperCase()}]:`, error)
        throw error;
    }
}


export { apiRequest, axiosUnauthInstance, axiosInstance };
